import * as log from "loglevel";
import { ACTIONS } from "UTILS/Constants";
import { socketMessage } from "WEBSOCKET/constants";
log.setLevel("info");

export const handleMessage = (data, store) => {
  switch (data.action) {
    case socketMessage.subCategories.APP_EMULATION._PERMISSION_REQUEST:
      store.dispatch({
        type: ACTIONS.APP_EMULATION.APP_EMULATION_REQUEST,
        value: true
      });
      break;

    case socketMessage.subCategories.APP_EMULATION._PERMISSION_REPLY:
      store.dispatch({
        type: ACTIONS.APP_EMULATION._APP_EMULATION_REPLY,
        // 2022-12-07 exCloserSV からの response 時に true を固定しておくと、フォロワー側で AppEmulation のモーダルが表示されてしまうので、false 固定にする
        // value: true
        value: false,
      });
      if (data && data.uniqueId && !data.isGranted) {
        store.dispatch({
          type: ACTIONS.APP_EMULATION.PERMISSION_DENIDED,
          value: data.uniqueId
        });
      }
      break;

    case socketMessage.subCategories.APP_EMULATION._STOP_APP_EMULATION_SESSION:
      let appEmulationState = store.getState().AppEmulationReducer;

      if (
        appEmulationState.appEmulationPermisssionReply ||
        appEmulationState.appEmulationPermissionRequest
      ) {
        store.dispatch({
          type: ACTIONS.APP_EMULATION.APP_EMULATION_END_SESSION
        });
      }
      break;
    
    case socketMessage.subCategories.APP_EMULATION._PARTICIPANT_LEFT:
      store.dispatch({
        type: ACTIONS.APP_EMULATION.APP_EMULATION_LEAVE_SESSION,
        value: data.uniqueId
      });
      break;
    
    case socketMessage.subCategories.APP_EMULATION._PARTICIPANT_ARRIVED:
      store.dispatch({
        type: ACTIONS.APP_EMULATION.APP_EMULATION_JOIN_SESSION,
        value: data.uniqueId
      });
      break;
  }
};
